module.exports = __webpack_public_path__ + "img/49.a96cef9e.jpg";